import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const matchDetailDefaultLayout: LayoutRuntime = {
  feature: "match-detail",
  layout: "default",
  rootClass: "gwd-livescore-layout--default",
};
